if (!customElements.get('variant-pills-selector')) {
  customElements.define('variant-pills-selector', class extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('.product--variant-pills-data');
      this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];

      this.selectedOptions = {};
      this.querySelectorAll('.product--variant-pill--active').forEach(pill => {
        this.selectedOptions[pill.dataset.optionPosition] = pill.dataset.optionValue;
      });

      this.addEventListener('click', this.onPillClick.bind(this));
    }

    onPillClick(event) {
      const pill = event.target.closest('button.product--variant-pill');
      if (!pill) return;

      const position = pill.dataset.optionPosition;
      const value = pill.dataset.optionValue;

      this.querySelectorAll(`.product--variant-pill[data-option-position="${position}"]`).forEach(p => {
        p.classList.remove('product--variant-pill--active');
        p.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('product--variant-pill--active');
      pill.setAttribute('aria-pressed', 'true');

      this.selectedOptions[position] = value;

      const variant = this.findVariant();
      if (variant && variant.featured_image) {
        this.updateCardImage(variant.featured_image);
      }
    }

    findVariant() {
      return this.variants.find(variant =>
        Object.entries(this.selectedOptions).every(
          ([pos, val]) => variant['option' + pos] === val
        )
      );
    }

    updateCardImage(featuredImage) {
      const card = this.closest('.product-grid-item');
      if (!card) return;
      const img = card.querySelector('.product__media_thumbnail img:not(.secondary__img)');
      if (!img) return;

      const rawSrc = featuredImage.src;
      const base = rawSrc.indexOf('?') !== -1 ? rawSrc.substring(0, rawSrc.indexOf('?')) : rawSrc;
      const versionMatch = rawSrc.match(/v=([^&]+)/);
      const vStr = versionMatch ? ('v=' + versionMatch[1] + '&') : '';

      const sized = w => base + '?' + vStr + 'width=' + w;
      const maxW = featuredImage.width || 1066;

      img.src = sized(533);
      img.srcset = [165, 360, 533, 720, 940, 1066]
        .filter(w => maxW >= w)
        .map(w => sized(w) + ' ' + w + 'w')
        .join(', ');

      if (featuredImage.alt != null) img.alt = featuredImage.alt;
    }
  });
}
